var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("v-card", { attrs: { flat: "" } }, [
        _c("div", { attrs: { id: "controlsContainer" } }, [
          _c(
            "div",
            {
              staticClass:
                "card-title table-controls px-3 d-flex align-center justify-space-between"
            },
            [
              _c("div"),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "filterContainer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { sm: "12", md: "4", cols: "12" } },
                            [
                              !_vm.$userIsAdmin()
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$t("postalCodes.agency"),
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.filter.agencyCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "agencyCode", $$v)
                                      },
                                      expression: "filter.agencyCode"
                                    }
                                  })
                                : _vm._e(),
                              _vm.$userIsAdmin()
                                ? _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.agenciesFilterItems,
                                      loading: _vm.agenciesFilter.isLoading,
                                      "search-input": _vm.agenciesFilter.search,
                                      "hide-no-data": "",
                                      "no-data-text": _vm.$t(
                                        "global.autocomplete.noDataFound"
                                      ),
                                      "item-text": "description",
                                      "item-value": "code",
                                      label: _vm.$t("postalCodes.agency"),
                                      placeholder: _vm.$t(
                                        "global.autocomplete.starTypingToSearch"
                                      ),
                                      clearable: ""
                                    },
                                    on: {
                                      "update:searchInput": function($event) {
                                        return _vm.$set(
                                          _vm.agenciesFilter,
                                          "search",
                                          $event
                                        )
                                      },
                                      "update:search-input": function($event) {
                                        return _vm.$set(
                                          _vm.agenciesFilter,
                                          "search",
                                          $event
                                        )
                                      },
                                      focus: function($event) {
                                        _vm.agenciesFilter.isEdit = true
                                      },
                                      change: function($event) {
                                        _vm.agenciesFilter.isEdit = false
                                      }
                                    },
                                    model: {
                                      value: _vm.filter.agencyCode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filter, "agencyCode", $$v)
                                      },
                                      expression: "filter.agencyCode"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "4", lg: "4", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "esc",
                                          27,
                                          $event.key,
                                          ["Esc", "Escape"]
                                        )
                                      )
                                        return null
                                      _vm.modalFilterDateFrom = false
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "statistics.dateFrom"
                                                  ),
                                                  "append-icon":
                                                    "far fa-calendar-alt",
                                                  readonly: "",
                                                  clearable: ""
                                                },
                                                on: {
                                                  "click:clear": function(
                                                    $event
                                                  ) {
                                                    _vm.filter.dateFrom = null
                                                  }
                                                },
                                                model: {
                                                  value: _vm.dateFromFormatted,
                                                  callback: function($$v) {
                                                    _vm.dateFromFormatted = $$v
                                                  },
                                                  expression:
                                                    "dateFromFormatted"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.modalFilterDateFrom,
                                    callback: function($$v) {
                                      _vm.modalFilterDateFrom = $$v
                                    },
                                    expression: "modalFilterDateFrom"
                                  }
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: { scrollable: "" },
                                      on: {
                                        input: function($event) {
                                          _vm.modalFilterDateFrom = false
                                        }
                                      },
                                      model: {
                                        value: _vm.filter.dateFrom,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filter, "dateFrom", $$v)
                                        },
                                        expression: "filter.dateFrom"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.modalFilterDateFrom = false
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("global.cancel")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "4", lg: "4", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    keydown: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "esc",
                                          27,
                                          $event.key,
                                          ["Esc", "Escape"]
                                        )
                                      )
                                        return null
                                      _vm.modalFilterDateTo = false
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "statistics.dateTo"
                                                  ),
                                                  "append-icon":
                                                    "far fa-calendar-alt",
                                                  readonly: "",
                                                  clearable: ""
                                                },
                                                on: {
                                                  "click:clear": function(
                                                    $event
                                                  ) {
                                                    _vm.filter.dateTo = null
                                                  }
                                                },
                                                model: {
                                                  value: _vm.dateToFormatted,
                                                  callback: function($$v) {
                                                    _vm.dateToFormatted = $$v
                                                  },
                                                  expression: "dateToFormatted"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.modalFilterDateTo,
                                    callback: function($$v) {
                                      _vm.modalFilterDateTo = $$v
                                    },
                                    expression: "modalFilterDateTo"
                                  }
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: { scrollable: "" },
                                      on: {
                                        input: function($event) {
                                          _vm.modalFilterDateTo = false
                                        }
                                      },
                                      model: {
                                        value: _vm.filter.dateTo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filter, "dateTo", $$v)
                                        },
                                        expression: "filter.dateTo"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.modalFilterDateTo = false
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("global.cancel")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "4", lg: "4", cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.groupByItemsValues,
                                  label: _vm.$t("statistics.groupBy")
                                },
                                model: {
                                  value: _vm.filter.groupBy,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "groupBy", $$v)
                                  },
                                  expression: "filter.groupBy"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "4", lg: "4", cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.orderByItemsValues,
                                  label: _vm.$t("statistics.orderBy")
                                },
                                model: {
                                  value: _vm.orderBy,
                                  callback: function($$v) {
                                    _vm.orderBy = $$v
                                  },
                                  expression: "orderBy"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      large: "",
                      color: "blue",
                      icon: "fa-sync-alt",
                      tooltip: _vm.$t("global.crud.buttons.refreshTable")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.search()
                      }
                    }
                  }),
                  _c("ExportExcel", {
                    attrs: {
                      url: "/timeSlots/statistics-grouped",
                      filter: this.filter,
                      filterExport: _vm.filterExport,
                      processFilter: _vm.processFilter,
                      itemsPerPage: "10000"
                    }
                  })
                ],
                1
              )
            ]
          )
        ]),
        _c(
          "div",
          { attrs: { id: "dataContainer" } },
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.items,
                options: _vm.options,
                page: _vm.pagination.page,
                "server-items-length": _vm.pagination.totalItems,
                "no-results-text": _vm.$t("global.datatable.noMatchingResults"),
                "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                "footer-props": {
                  "items-per-page-options": _vm.rowsPerPageItems,
                  "show-first-last-page": true,
                  "show-current-page": true
                },
                loading: _vm.loading,
                light: "",
                "multi-sort": "",
                dense: ""
              },
              on: {
                "update:options": function($event) {
                  _vm.options = $event
                },
                "update:page": function($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function({ items }) {
                    return [
                      _c(
                        "tbody",
                        _vm._l(items, function(item) {
                          return _c(
                            "tr",
                            {
                              key:
                                item.agencyCode +
                                item.zoneCode +
                                item.date +
                                item.name
                            },
                            [
                              _c(
                                "td",
                                [
                                  _c("ExportExcel", {
                                    attrs: {
                                      url: "/timeSlots/statistics-single",
                                      filter: _vm.rowExportFilter,
                                      processFilter: _vm.processRowExportFilter,
                                      filterExport: _vm.filterExport,
                                      item: item
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("td", [_vm._v(_vm._s(item.agencyCode))]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.transformDate(
                                      item.date,
                                      _vm.$t("global.dateFormat")
                                    )
                                  )
                                )
                              ]),
                              _vm.resultLevel != "summary"
                                ? _c("td", [_vm._v(_vm._s(item.zoneCode))])
                                : _vm._e(),
                              _vm.resultLevel == "detail"
                                ? _c("td", [_vm._v(_vm._s(item.name))])
                                : _vm._e(),
                              _vm.resultLevel == "detail"
                                ? _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.minutesToHour(item.hourFrom)
                                        ) +
                                        " - " +
                                        _vm._s(_vm.minutesToHour(item.hourTo)) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.minutesFormat(item.plannedDeliveryTime)
                                  )
                                )
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.minutesFormat(
                                      item.availableDeliveryTime
                                    )
                                  )
                                )
                              ]),
                              _c(
                                "td",
                                { staticClass: "progress-bar" },
                                [
                                  _c(
                                    "v-progress-linear",
                                    {
                                      attrs: {
                                        value: item.occupation,
                                        color:
                                          item.occupation >= 90
                                            ? "pink"
                                            : item.occupation >= 70
                                            ? "amber"
                                            : "green",
                                        height: "25"
                                      }
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(Math.ceil(item.occupation)) +
                                            "%"
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }